import { IconButton, squareBlockCSS } from '@braskai/ui-kit';

import { css, styled } from '@mui/material';

export const SIconButton = styled(IconButton)(
  ({ theme }) => css`
    ${squareBlockCSS(36)};
    padding: 8px;
    border-radius: 8px;
    border: 1px solid ${theme.palette.grey[300]};
    background: ${theme.palette.common.white};
    color: ${theme.palette.grey[700]};
    cursor: pointer;

    &:hover {
      background: ${theme.palette.grey[50]};
    }

    ${theme.breakpoints.up('tablet')} {
      ${squareBlockCSS(40)};
    }
  `,
);
